import googlemap from "javascripts/googlemap";

document.addEventListener("DOMContentLoaded", () => {
  const canvas = document.getElementById("map-canvas");
  if (!canvas) {
    return;
  }

  googlemap.then((maps) => {
    const latlng = new maps.LatLng(canvas.dataset.lat, canvas.dataset.lng);
    const map = new maps.Map(canvas, {
      zoom: 13,
      fullscreenControl: false,
      center: latlng,
      gestureHandling: "none",
      mayTypeId: maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      zoomControl: false,
      clickableIcons: false,
      draggableCursor: "default",
    });
    new maps.Marker({ position: latlng, map: map, icon: { url: canvas.dataset.imageUrl, scaledSize: new maps.Size(40, 40) } });
  });
});
